import { render, staticRenderFns } from "./access-control-event-table.vue?vue&type=template&id=6c10ee1f&scoped=true&"
import script from "./access-control-event-table.ts?vue&type=script&lang=ts&"
export * from "./access-control-event-table.ts?vue&type=script&lang=ts&"
import style0 from "./access-control-event-table.scss?vue&type=style&index=0&id=6c10ee1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c10ee1f",
  null
  
)

export default component.exports